export default __webpack_public_path__ + "static/media/sticker-animation-light@1x.fe3e1704.webp";